import { ethereumMainnetNetworks } from "./ethereumMainnetChains";
export var getCelerBridgeChainOptions = function (_a) {
    var chainId = _a.chainId;
    return Object.keys(ethereumMainnetNetworks).map(function (key) {
        var itemKey = key;
        var celerBridgeChainId = String(ethereumMainnetNetworks[itemKey].chainId);
        if (celerBridgeChainId === chainId)
            return;
        return ({
            value: celerBridgeChainId,
            chainId: celerBridgeChainId,
            name: ethereumMainnetNetworks[itemKey].name,
            symbol: ethereumMainnetNetworks[itemKey].symbol,
        });
    }).filter(Boolean);
};
